import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { updateReservation } from "@/features/reservation/reservationSlice";

const ReservationCountdown: React.FC = () => {
  const lockAtMs = useAppSelector((s) => s.reservation.lockAtMs);
  const countdownActive = useAppSelector((s) => s.reservation.countdownActive);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!lockAtMs) return;

    const tick = () => {
      const remainingMs = Math.max(0, lockAtMs - Date.now());
      const remainingTotalSeconds = Math.floor(remainingMs / 1000);
      const remMinutes = Math.floor(remainingTotalSeconds / 60);
      const remSeconds = remainingTotalSeconds % 60;
      const label = `${String(remMinutes).padStart(2, "0")}:${String(
        remSeconds,
      ).padStart(2, "0")}`;
      dispatch(updateReservation({ timeRemainingLabel: label }));
    };

    // Only run ticking countdown when within threshold or already active
    if (countdownActive) {
      tick();
      const id = window.setInterval(tick, 1000);
      return () => window.clearInterval(id);
    } else {
      // Keep a lightweight timer to flip into active once threshold hits
      const flipCheck = window.setInterval(() => {
        const remainingMs = Math.max(0, lockAtMs - Date.now());
        if (remainingMs <= 90 * 60 * 1000) {
          window.clearInterval(flipCheck);
          // Trigger activation; label will be computed by active ticker on next render
          dispatch(updateReservation({ countdownActive: true }));
        }
      }, 30 * 1000);
      return () => window.clearInterval(flipCheck);
    }
  }, [dispatch, lockAtMs, countdownActive]);

  return null;
};

export default ReservationCountdown;
